import React from "react"
import Components from "../index"

import { blokType } from "../../types"
import {
  StyledCardResearchSmall,
  StyledCardSmallContainer,
  StyledCardResearchCategory,
  StyledCardResearchText,
  StyledCardResearchSmallTitle,
  StyledCardResearchSmallAuthor,
  StyledButtonSmall,
} from "./partials"

export interface CardResearchSmallProps {
  category: string
  title: string
  author: string
  cta_button: blokType[]
  font_color: string
}

export const CardResearchSmallCmp: React.FC<CardResearchSmallProps> = ({
  category,
  title,
  author,
  cta_button,
  font_color,
}) => (
  <StyledCardResearchSmall>
    <StyledCardSmallContainer>
      <StyledCardResearchText font_color={font_color}>
        {category && (
          <StyledCardResearchCategory>{category}</StyledCardResearchCategory>
        )}
        {title && (
          <StyledCardResearchSmallTitle>{title}</StyledCardResearchSmallTitle>
        )}
        {author && (
          <StyledCardResearchSmallAuthor>
            {author}
          </StyledCardResearchSmallAuthor>
        )}
      </StyledCardResearchText>

      <StyledButtonSmall>
        {cta_button &&
          cta_button.map((content: blokType) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
      </StyledButtonSmall>
    </StyledCardSmallContainer>
  </StyledCardResearchSmall>
)
